import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "chevron"]

  connect() {
    // Close menu when clicking outside
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  toggle() {
    const isOpen = !this.menuTarget.classList.contains("hidden")

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.chevronTarget.classList.add("rotate-180", "text-[#58CC02]")
    this.buttonTarget.classList.remove("border-b-4")
    this.buttonTarget.classList.add("border-b-2", "translate-y-1", "border-[#58CC02]")
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-180", "text-[#58CC02]")
    this.buttonTarget.classList.add("border-b-4")
    this.buttonTarget.classList.remove("border-b-2", "translate-y-1", "border-[#58CC02]")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  selectLocale(event) {
    // Close menu after selection, form will submit naturally
    this.close()
  }
}
